module.exports = __webpack_public_path__ + "static/media/form_640_color.1e2785db.png";